<template>
  <div class="range-slider js">
    <input
      v-model="newValue"
      type="range"
      :min="min"
      :max="max"
      :step="step"
      class="range-slider__range"
      :style="{ '--min': min, '--max': max, '--val': newValue }"
    />
  </div>
</template>

<script>
import VModelCompat from '~/mixins/v_model_compat';

export default {
  name: 'AppRangeSlider',
  mixins: [VModelCompat],
  props: {
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 50000,
    },
    step: {
      type: Number,
      default: 10,
    },
    modelValue: {
      type: Number,
      default: undefined,
    },
    value: {
      type: Number,
      default: undefined,
    },
  },
  emits: ['update:modelValue', 'input'],
  computed: {
    newValue: {
      get() {
        return this.modelCompatValue;
      },
      set(newValue) {
        this.emitModelCompatValue(Number(newValue));
      },
    },
  },
};
</script>
